import * as t from 'io-ts';
import { optional } from './helper';

export const raceGrid = t.array(t.type({
  Time: optional(t.string),
  LastName: t.string,
  Initials: t.string,
  FullName: t.string,
  Country: optional(t.string),
  TeamName: t.string,
}));
export type RaceGrid = t.TypeOf<typeof raceGrid>;

export const driverStandings = t.array(t.type({
  Position: t.number,
  Points: t.string,
  Initials: t.string,
  LastName: t.string,
  FullName: t.string,
  Country: optional(t.string),
}));
export type DriverStandings = t.TypeOf<typeof driverStandings>;

export const teamStandings = t.array(t.type({
  Position: t.number,
  Points: t.string,
  TeamName: t.string,
}));
export type TeamStandings = t.TypeOf<typeof teamStandings>;
